/**
 * Tiny-Slider Entry Point
 * Separate bundle for pages that need the slider functionality
 *
 * @author  Mario Lorenz, www.buchsuite.de
 * @license https://www.gnu.org/licenses/gpl-2.0.html GNU General Public License, version 2
 */

// Import styles
import '../vendor/tiny-slider/scss/tiny-slider.oxid.scss';

// Import tiny-slider library
import { tns } from 'tiny-slider';

// Import OXID customizations
import { initSliders } from '../vendor/tiny-slider/js/tiny-slider.oxid.js';

// Expose tns globally on window object for external usage
if (typeof window !== 'undefined') {
    window.tns = tns;
    window.initSliders = initSliders;
}

// Auto-initialize sliders when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
} else {
    initSliders();
}
